import { getApiErrorI18nKey } from "@noa/api-client";
import { useTranslation } from "react-i18next";
import { Alert } from "~/components/ui";
import { corpusProblem } from "~/utils/corpus-admin";

interface CorpusErrorAlertProps {
  error: unknown;
  className?: string;
}

/** What to change when the server refused a corpus request; the failure itself otherwise. */
export function CorpusErrorAlert({ error, className }: CorpusErrorAlertProps) {
  const { t, i18n } = useTranslation("admin");
  const formatNumber = (value: number) => value.toLocaleString(i18n.language);
  const problem = corpusProblem(error);

  switch (problem?.code) {
    case "too_broad":
      return (
        <Alert
          type="warning"
          showIcon
          className={className}
          message={t("vectorstoreAdmin.tooBroad.title")}
          description={t("vectorstoreAdmin.tooBroad.description", {
            matched: formatNumber(problem.matched),
            limit: formatNumber(problem.limit),
          })}
        />
      );
    case "too_many":
      return (
        <Alert
          type="warning"
          showIcon
          className={className}
          message={t("vectorstoreAdmin.deletion.tooMany", {
            requested: formatNumber(problem.requested),
            limit: formatNumber(problem.limit),
          })}
        />
      );
    case "invalid_filter":
      return (
        <Alert
          type="warning"
          showIcon
          className={className}
          message={t(`vectorstoreAdmin.invalidFilter.${problem.reason}`, {
            field: problem.field,
            type: problem.document_type,
          })}
        />
      );
    default:
      return <Alert type="error" showIcon className={className} message={t(getApiErrorI18nKey(error))} />;
  }
}
